import { LocalPhone, PhoneDisabled } from '@mui/icons-material';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import {
  decreaseAlarmsCount,
  getConferenceAlarmsList,
  selectConferenceAlarms,
  setAlarmAsRead,
  setVideoCallInfo,
} from 'app/store/alarmsSlice';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getAbsoluteFileUrl } from 'src/app/helpers/utils';

const VideoCallDialog = ({ videoCallInfo }) => {
  const { t } = useTranslation('translations');
  const dispatch = useDispatch();
  const conferenceAlarms = useSelector(selectConferenceAlarms);

  const extractUrl = (text) => {
    if (!text) return null;
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const matches = text.match(urlRegex);
    return matches ? matches[0] : null;
  };

  useEffect(() => {
    let timer = null;

    if (videoCallInfo) {
      // Закрыть через 1 минуту (60000 мс)
      timer = setTimeout(() => {
        dispatch(setVideoCallInfo(null));
      }, 60000);
    }

    return () => {
      clearTimeout(timer); // очистка таймера при закрытии/размонтировании
    };
  }, [videoCallInfo]);

  const url = videoCallInfo ? extractUrl(videoCallInfo.text) : null;
  const answerCall = () => {
    if (conferenceAlarms && conferenceAlarms?.length) {
      dispatch(setAlarmAsRead({ id: conferenceAlarms[0]?.id }));
      dispatch(decreaseAlarmsCount());
    }
    if (url) {
      window.open(url, '_blank');
    }
    dispatch(setVideoCallInfo(null));
  };

  function functionEndCall() {
    if (conferenceAlarms && conferenceAlarms?.length) {
      dispatch(setAlarmAsRead({ id: conferenceAlarms[0]?.id }));
      dispatch(decreaseAlarmsCount());
    }
    dispatch(setVideoCallInfo(null));
  }

  const handleClose = () => {
    // if (reason === 'backdropClick') return;
    dispatch(setVideoCallInfo(null));
  };

  return (
    <Dialog open={!!videoCallInfo} onClose={handleClose}>
      <DialogTitle>{t('InvitationToVideoConference')}</DialogTitle>
      <DialogContent>
        <div className="flex flex-col justify-between  min-h-[200px] md:min-w-[250px]">
          <div className="text-center mb-10">
            <img
              src={
                videoCallInfo?.staffFullName?.imagePath
                  ? getAbsoluteFileUrl(videoCallInfo.staffFullName.imagePath)
                  : 'assets/images/pages/profile/no_photo.jpg'
              }
              alt={t('Videoconference')}
              className="rounded-full w-112 h-112 mx-auto mb-4"
            />
            <h2 className="text-lg font-semibold">{videoCallInfo?.staffFullName?.name || ''}</h2>
          </div>
          <div className="flex justify-between items-center">
            <div>
              <button
                onClick={answerCall}
                className="bg-green-500 rounded-full text-white p-20 circle"
              >
                <LocalPhone className="animate-bounce" />
              </button>
            </div>

            <div>
              <button
                onClick={functionEndCall}
                className="bg-red-500 rounded-full text-white p-20 circle"
              >
                <PhoneDisabled />
              </button>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default VideoCallDialog;
